import { combineReducers } from "redux";

export const selectedMessageReducer = (selectedMessage = null, action: { type: string; payload: any; }) => {
    if (action.type === 'MESSAGE_SELECTED') {
        return action.payload;
    }
    return selectedMessage;
}

export const messagesListReducer = (messages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_MESSAGES') {
        return action.payload
    }
    return messages;
};

export const allSentNotificationsListReducer = (sentMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_ALL_SENTNOTIFICATIONS') {
        return action.payload
    }
    return sentMessages;
};

export const scheduledMessagesReducer = (scheduledMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_SCHEDULED_MESSAGES') {
        return action.payload
    }
    return scheduledMessages;
};

export const draftmessagesListReducer = (draftMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_DRAFTMESSAGES') {
        return action.payload
    }
    return draftMessages;
};

export const loadApplicationConfigReducer = (state: IApplicationConfig = {}, action: { type: string, payload: IApplicationConfig }) => {
    if (action.type === 'FETCH_CONFIGURATION') {
        return action.payload
    }
    return state;
}

export const selectedTemplateReducer = (selectedTemplate = null, action: { type: string; payload: any; }) => {
    if (action.type === 'TEMPLATE_SELECTED') {
        return action.payload;
    }
    return selectedTemplate;
}

export const templatesListReducer = (templates = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_ALL_TEMPLATES') {
        return action.payload
    }
    return templates;
};

export const templateColorsListReducer = (templateColors = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_TEMPLATE_COLORS') {
        return action.payload
    }
    return templateColors;
};

export interface IApplicationConfig {
    proxyUrl?: string,
    coreServicesUrl?: string,
    analyticsServicesUrl?: string,
}

export default combineReducers({
    messagesList: messagesListReducer,
    draftMessagesList: draftmessagesListReducer,
    selectedMessage: selectedMessageReducer,
    scheduledMessages: scheduledMessagesReducer,
    allNotificationMessages: allSentNotificationsListReducer,
    appConfig: loadApplicationConfigReducer,
    selectedTemplate: selectedTemplateReducer,
    templatesList: templatesListReducer,
    templateColorsList: templateColorsListReducer,
});